export const addKeyPropInData = (array: any[]) => {
  return array.map((arrayElement, index) => ({
    ...arrayElement,
    key: index,
  }));
};
